export const slideMenu = () => {
    const navigation = document.querySelector('.header__nav');

    if (!navigation) return;

    const backLabel = (typeof bnlabels !== 'undefined' && bnlabels && bnlabels.back) ? bnlabels.back : 'Wróć';

    // Only select first-level submenu toggles
    const dropdownToggles = navigation.querySelectorAll(':scope > ul > .menu-item-has-children > .submenu-toggle');

    const originalMenu = navigation.querySelector(':scope > ul');
    if (!originalMenu) return;

    // Add classes to original menu for animations
    originalMenu.classList.add('menu-panel', 'slide-in');

    // Stack to remember panel history (including original menu)
    const panelStack = [originalMenu];
    let isProcessing = false; // Prevent multiple clicks

    // Helper to close all panels
    const closeAllPanels = () => {
        const allPanels = navigation.querySelectorAll('.slide-menu-panel');
        allPanels.forEach(panel => {
            if (panel._focusTrapHandler) {
                panel.removeEventListener('keydown', panel._focusTrapHandler);
            }
            panel.remove();
        });

        // Reset original menu to slide-in position
        originalMenu.classList.remove('slide-out-left');
        originalMenu.classList.add('slide-in');
        panelStack.length = 1; // Keep original menu in stack
        panelStack[0] = originalMenu;
    };

    // Helper to get focusable elements
    const getFocusableElements = (container) => {
        return container.querySelectorAll(
            'a[href], button, input, textarea, select, details, [tabindex]:not([tabindex="-1"])'
        );
    };

    // Helper to trap focus within a container
    const trapFocus = (container) => {
        const focusableElements = getFocusableElements(container);
        const firstFocusable = focusableElements[0];
        const lastFocusable = focusableElements[focusableElements.length - 1];

        // Remove any existing focus trap listeners
        container.removeEventListener('keydown', container._focusTrapHandler);

        container._focusTrapHandler = (e) => {
            if (e.key === 'Tab') {
                if (e.shiftKey) {
                    // Shift + Tab
                    if (document.activeElement === firstFocusable) {
                        e.preventDefault();
                        // Close all panels when trying to tab backwards from first element
                        closeAllPanels();
                        return;
                    }
                } else {
                    // Tab
                    if (document.activeElement === lastFocusable) {
                        e.preventDefault();
                        // Close all panels when trying to tab forwards from last element
                        closeAllPanels();
                        return;
                    }
                }
            }
            // Handle Escape key to go back
            if (e.key === 'Escape') {
                e.preventDefault();
                const globalBackBtn = document.querySelector('.slide-menu-back');
                if (globalBackBtn) {
                    globalBackBtn.click();
                }
            }
        };

        container.addEventListener('keydown', container._focusTrapHandler);

        // Focus the first <a> element instead of any focusable element
        const firstLink = container.querySelector('a');
        if (firstLink) {
            firstLink.focus();
        } else if (firstFocusable) {
            firstFocusable.focus();
        }
    };

    // Global focus listener to detect when focus leaves the slide panels
    document.addEventListener('focusin', (e) => {
        const activePanel = navigation.querySelector('.slide-in');
        if (activePanel && !activePanel.contains(e.target)) {
            // Focus moved outside the active panel, close all panels
            closeAllPanels();
        }
    });

    // Helper to create slide panel for a given menu item
    const createSlidePanel = (menuItem) => {
        // Get current active panel
        const currentPanel = panelStack[panelStack.length - 1];

        // Slide current panel to the left
        if (currentPanel) {
            currentPanel.classList.remove('slide-in');
            currentPanel.classList.add('slide-out-left');
            // Remove focus trap from previous panel
            if (currentPanel._focusTrapHandler) {
                currentPanel.removeEventListener('keydown', currentPanel._focusTrapHandler);
            }
        }

        // Create slide container
        const slideDiv = document.createElement('ul');
        slideDiv.classList.add('slide-menu-panel', 'menu-panel');

        // Add level-specific classes based on panel stack depth
        const panelLevel = panelStack.length; // Current level (1 = original, 2 = first submenu, etc.)
        slideDiv.classList.add(`menu-panel__level-${panelLevel}`);

        slideDiv.setAttribute('role', 'dialog');
        slideDiv.setAttribute('aria-label', `${menuItem.querySelector('a').textContent} submenu`);

        // Back button
        const backBtn = document.createElement('div');
        backBtn.innerHTML = `<button class="slide-menu-back">${backLabel}</button>`;
        backBtn.classList.add('slide-menu-back-item');
        slideDiv.appendChild(backBtn);

        const navSearch = navigation.querySelector('.header__nav-search-mobile');
        if (navSearch) {
            // design: search field sits above the back button
            const navSearchClone = navSearch.cloneNode(true);
            navSearchClone.classList.add('slide-menu-nav-search');
            backBtn.insertBefore(navSearchClone, backBtn.firstChild);
        }

        // Current menu item title
        const titleItem = document.createElement('li');
        const title = document.createElement('a');
        titleItem.classList.add('slide-menu-title');
        title.textContent = menuItem.querySelector('a').textContent;
        title.href = menuItem.querySelector('a').href || '#';
        title.target = menuItem.querySelector('a').target || '_self';
        title.classList.add('slide-menu-title-item');
        titleItem.appendChild(title);
        slideDiv.appendChild(titleItem);

        // First-level children: plain items flow into a multi-column grid,
        // button-style items (e.g. "ZOBACZ WSZYSTKIE KRAJE") go full-width below.
        const childrenList = menuItem.querySelector('ul');
        if (childrenList) {
            const cloneList = childrenList.cloneNode(true);
            const grid = document.createElement('div');
            grid.classList.add('slide-menu-items');
            const buttons = [];
            Array.from(cloneList.children).forEach(child => {
                child.classList.add('slide-menu-subitem');
                if (child.classList.contains('bn-button')) {
                    buttons.push(child);
                } else {
                    grid.appendChild(child);
                }
            });
            // A list that ships a button (e.g. countries → "ZOBACZ WSZYSTKIE KRAJE")
            // renders in two columns; a plain submenu (services, …) stays single-column.
            if (buttons.length) {
                grid.classList.add('slide-menu-items--two-col');
            }
            slideDiv.appendChild(grid);
            buttons.forEach(b => slideDiv.appendChild(b));
        }

        // Add to stack before appending to DOM
        panelStack.push(slideDiv);
        navigation.appendChild(slideDiv);

        // Start from right position, then animate in
        slideDiv.style.transform = 'translateX(100%)';
        slideDiv.offsetHeight; // Force reflow

        // Trigger slide-in
        requestAnimationFrame(() => {
            slideDiv.classList.add('slide-in');
            slideDiv.style.transform = '';

            // Set up focus trap after animation starts
            setTimeout(() => {
                trapFocus(slideDiv);
            }, 50);
        });

        // Back button functionality
        const backButton = backBtn.querySelector('.slide-menu-back');
        backButton.addEventListener('click', handleBackClick);
    };

    // Back button handler
    const handleBackClick = (e) => {
        if (isProcessing) return;
        isProcessing = true;

        e.preventDefault();
        e.stopPropagation();

        const currentPanel = panelStack[panelStack.length - 1];

        // Remove focus trap from current panel
        if (currentPanel && currentPanel._focusTrapHandler) {
            currentPanel.removeEventListener('keydown', currentPanel._focusTrapHandler);
        }

        // If we're at the original menu, do nothing (or close all if desired)
        if (panelStack.length <= 1) {
            isProcessing = false;
            return;
        }

        // Remove current panel from stack
        panelStack.pop();
        const prevPanel = panelStack[panelStack.length - 1];

        // Animate current panel out
        currentPanel.classList.remove('slide-in');
        currentPanel.classList.add('slide-out-right');

        // Animate previous panel in
        if (prevPanel) {
            prevPanel.classList.remove('slide-out-left');
            prevPanel.classList.add('slide-in');

            // Only re-establish focus trap if it's not the original menu
            if (prevPanel !== originalMenu) {
                setTimeout(() => {
                    trapFocus(prevPanel);
                }, 100);
            }
        }

        // Remove current panel after animation
        if (currentPanel !== originalMenu) {
            currentPanel.addEventListener('transitionend', () => {
                setTimeout(() => {
                    currentPanel.remove();
                    isProcessing = false;
                }, 300);
            }, { once: true });
        } else {
            isProcessing = false;
        }
    };

    // Accordion: expand/collapse a top-level submenu inline (level 1)
    const toggleAccordion = (li) => {
        const sub = li.querySelector(':scope > .sub-menu');
        if (!sub) return;
        if (li.classList.contains('--open')) {
            sub.style.maxHeight = '';
            li.classList.remove('--open');
        } else {
            li.classList.add('--open');
            sub.style.maxHeight = `${sub.scrollHeight}px`;
        }
    };

    // Single click handler: top-level → inline accordion, deeper → slide drill.
    navigation.addEventListener('click', (e) => {
        if (isProcessing) return;
        // Mobile-only; desktop uses hover/focus flyouts.
        if (window.matchMedia('(min-width: 992px)').matches) return;

        const submenuToggle = e.target.closest('.submenu-toggle');
        if (!submenuToggle || !navigation.contains(submenuToggle)) return;

        const li = submenuToggle.closest('.menu-item-has-children');
        if (!li) return;

        e.preventDefault();
        e.stopPropagation();

        const inSlidePanel = !!submenuToggle.closest('.slide-menu-panel');
        // Top-level when the item's <ul> sits directly inside the nav (live check,
        // robust to any re-render of the menu after init).
        const isTopLevel = li.parentElement && li.parentElement.parentElement === navigation;

        if (isTopLevel && !inSlidePanel) {
            toggleAccordion(li);
            return;
        }

        isProcessing = true;
        createSlidePanel(li);
        setTimeout(() => { isProcessing = false; }, 300);
    });
};
